var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.length === 0 && !_vm.isView)?_c('Banner',{attrs:{"color":"info"},domProps:{"innerHTML":_vm._s(_vm.t('monitoringReceiver.webhook.banner', {}, _vm.raw=true))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }